import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Read more element, used to create an excerpt for slotted content
 *
 * @slot - Unnamed slot (default slot)
 * @attribute excerpt - mandatory, used to define the visible excerpt
 * @attribute readMore - mandatory, used to definte the read more text (to show full content)
 * @attribute readLess - mandatory, used to define the read less text (to hide full content)
 * @attribute hidden - optional, used to hide entire element
 *
 */
let SDBContentReadMore = class SDBContentReadMore extends LitElement {
    constructor() {
        super(...arguments);
        this.excerpt = '';
        this.readMore = '';
        this.readLess = '';
        this.opened = false;
    }
    render() {
        return html `
            <div>
                <div id="excerpt" part="excerpt" ?opened=${this.opened}>
                    ${this.excerpt} ...
                    <span id="readMoreBtn" @click="${this._readMoreLess}">
                        ${this.readMore}
                    </span>
                </div>
                <div id="fullText" part="fulltext" ?opened=${this.opened}>
                    <slot></slot>
                    <span id="readLessBtn" @click="${this._readMoreLess}">
                        &nbsp;${this.readLess}
                    </span>
                </div>
            </div>
        `;
    }
    _readMoreLess(e) {
        if (this.opened) {
            this.opened = false;
        }
        else {
            this.opened = true;
        }
        e.stopPropagation();
        return false;
    }
};
SDBContentReadMore.styles = [
    elements,
    css `
            :host {
                position: relative;
                display: block;
            }

            :host([hidden]),
            [hidden] {
                display: none;
            }

            #excerpt {
                display: block;
            }

            #excerpt[opened] {
                display: none;
            }

            #fullText {
                display: none;
            }

            #fullText[opened] {
                display: block;
            }

            #readMoreBtn,
            #readLessBtn {
                display: inline-block;
                font-size: 0.8em;
                color: var(--theme-primary);
                cursor: pointer;
            }

            #readMoreBtn:hover,
            #readLessBtn:hover {
                font-style: italic;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentReadMore.prototype, "excerpt", void 0);
__decorate([
    property({ type: String })
], SDBContentReadMore.prototype, "readMore", void 0);
__decorate([
    property({ type: String })
], SDBContentReadMore.prototype, "readLess", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentReadMore.prototype, "opened", void 0);
SDBContentReadMore = __decorate([
    customElement('sdb-content-readmore')
], SDBContentReadMore);
export { SDBContentReadMore };
//# sourceMappingURL=sdb-content-readmore.js.map